import React, { Component } from 'react';

class LoaderComponent extends Component {
  render() {
    return (
      <div className={`round-loader ${this.props.className}`}>
        <svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle fill="none" strokeWidth="8" strokeLinecap="round" cx="33" cy="33" r="28"></circle>
        </svg>
      </div>
    )
  }
}

export { LoaderComponent as Loader };